/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Divider, Layout, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import LicenseAgreementModal from "./LicenseAgreementModal";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function LicenseAgreementGateScreen({
  breadcrumbSlot,
  backHref,
  title,
  subtitle = "Sign the license agreement below to continue.",
  noticeSlot = null,
  titleLevel = 3,
  contractConfig,
  contractSigned,
  contractGateActive,
  contractSigning,
  onContractSign,
}) {
  return (
    <Layout style={{ minHeight: "60vh" }}>
      <Content className="vc-panel" style={{ padding: 24 }}>
        {noticeSlot}
        <Breadcrumb>{breadcrumbSlot}</Breadcrumb>
        <Divider />
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          {backHref ? (
            <Link to={backHref}>
              <ArrowLeftOutlined style={{ fontSize: 20 }} />
            </Link>
          ) : null}
          <Title level={titleLevel} style={{ margin: 0 }}>
            {title}
          </Title>
        </div>
        <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
          {subtitle}
        </Text>
        {contractConfig ? (
          <LicenseAgreementModal
            contractConfig={contractConfig}
            signed={contractSigned}
            mandatory={contractGateActive}
            open={contractGateActive}
            onSign={onContractSign}
            signing={contractSigning}
            showTriggerButton={false}
          />
        ) : null}
      </Content>
    </Layout>
  );
}
